import { put, takeEvery, take } from 'redux-saga/effects';
import { AblyChannelSingleton } from 'utils/push-notifications';
import {
  APP_AUCTIONS_GET_PUSH_NOTIFICATION_TOKEN,
  APP_NOTIFICATION_REFRESH_TOKEN
} from 'constants/action-types';

import {
  OnHighestBidChanged,
  onIncomingMessage,
  scheduleRefreshNotificationToken
} from 'store/site-actions';

const auctionSpecificNotifications = [
  {
    events: ['jta-bid-changed'],
    action: OnHighestBidChanged
  }
];

function* scheduleRenewRefreshToken({ payload: { timeout, channelName, token } }) {
  const prevTimeoutID = localStorage.getItem('renewRefreshTokenID');
  if (prevTimeoutID) {
    clearTimeout(prevTimeoutID);
  }
  const id = yield setTimeout(() => {
    AblyChannelSingleton.removeInstance(channelName, token);
  }, timeout);

  localStorage.setItem('renewRefreshTokenID', JSON.stringify(id));
}

const createSubscribeToPushNotification = specificNotifications =>
  function* subscribeToPushNotification(action) {
    try {
      const { token, channelName, expires } = action.payload;
      const ablyChannel = AblyChannelSingleton.getInstance(token, channelName, onIncomingMessage, [
        ...specificNotifications
      ]);
      const timeOutMS = new Date(expires) - new Date() - 60000;

      yield put(scheduleRefreshNotificationToken(timeOutMS, channelName, token));

      while (true) {
        try {
          const ablyAction = yield take(ablyChannel);
          yield put(ablyAction);
        } catch (e) {
          console.log('while loop Inner Error: ', e);
        }
      }
    } catch (e) {
      console.log('while loop Outer Error: ', e);
    }
  };

export default function* notificationsSaga() {
  yield takeEvery(
    APP_AUCTIONS_GET_PUSH_NOTIFICATION_TOKEN.success,
    createSubscribeToPushNotification(auctionSpecificNotifications)
  );
  yield takeEvery(APP_NOTIFICATION_REFRESH_TOKEN, scheduleRenewRefreshToken);
}
